import { combineReducers } from 'redux';

import { keepSession as authentication } from './authentication/authentication';
import { captcha } from './captcha/captcha';
import { exchange } from './exchange/exchange';
import { modals } from './modals';
import { pagination } from './pagination/pagination';
import {
  apiReadOnlyFields,
  attemptedInvalidSMSNumber,
  autofillSignupCompleted,
  autoLoadOnlineScript,
  cardElementFlowEnabled,
  cardRevampEnabled,
  createPaymentFailure,
  currentStepIndex,
  dismissedCreatePaymentAlertKey,
  docCollectorFinished,
  duplicatedPANNumber,
  duplicatedPayment,
  dynamicEditFields,
  embedded,
  embeddedConfirmationStep,
  fieldValues,
  gatewayOrigin,
  gatewaySource,
  hideCancelPaymentOption,
  hideUserManagement,
  isChatVisible,
  isDocumentsFetchFailure,
  isImpersonatingUser,
  isPaymentProcess,
  isRepeatingPayment,
  isTrackingPage,
  justCompletedPayment,
  lastPaymentFromSameRecipient,
  locale,
  lrsSignSuccessVisible,
  maxAmount,
  notifications,
  paymentsFromIndia,
  prefilledFields,
  prefilledRejectOrConfirm,
  readOnlyFields,
  receiveSMSNotification,
  receiveWhatsappNotification,
  redirectToReferrer,
  refundKYCProcessCompleted,
  repeatUpopPaymentEnabled,
  rewardsCurrency,
  showOfflineInstructions,
  taxServiceUnavailable,
  theme,
  userExists,
  validRefundKYCToken,
} from './ui';

const ui = combineReducers({
  apiReadOnlyFields,
  attemptedInvalidSMSNumber,
  authentication,
  autofillSignupCompleted,
  autoLoadOnlineScript,
  cardElementFlowEnabled,
  cardRevampEnabled,
  createPaymentFailure,
  currentStepIndex,
  dismissedCreatePaymentAlertKey,
  docCollectorFinished,
  duplicatedPayment,
  duplicatedPANNumber,
  dynamicEditFields,
  embedded,
  embeddedConfirmationStep,
  exchange,
  fieldValues,
  gatewayOrigin,
  gatewaySource,
  hideCancelPaymentOption,
  hideUserManagement,
  isChatVisible,
  isDocumentsFetchFailure,
  isImpersonatingUser,
  isPaymentProcess,
  isRepeatingPayment,
  isTrackingPage,
  justCompletedPayment,
  lastPaymentFromSameRecipient,
  locale,
  lrsSignSuccessVisible,
  maxAmount,
  modals,
  notifications,
  pagination,
  paymentsFromIndia,
  rewardsCurrency,
  prefilledFields,
  prefilledRejectOrConfirm,
  readOnlyFields,
  receiveSMSNotification,
  receiveWhatsappNotification,
  redirectToReferrer,
  refundKYCProcessCompleted,
  showOfflineInstructions,
  taxServiceUnavailable,
  theme,
  repeatUpopPaymentEnabled,
  userExists,
  validRefundKYCToken,
  captcha,
});

export { ui };
